export const VALIDATE = {
  _COMMON: {
    INPUT_REQUIRED: {
      MESSAGE: '入力してください',
    },
    SELECT_REQUIRED: {
      MESSAGE: '選択してください',
    },
    ONE_THOUSAND_CHARACTERS: {
      MAX: {
        VALUE: 1000,
        MESSAGE: '1000文字以下で入力してください',
      },
    },
    TWO_HUNDRED_FIFTY_FIVE_CHARACTERS: {
      MAX: {
        VALUE: 255,
        MESSAGE: '255文字以下で入力してください',
      },
    },
    ONE_HUNDRED_CHARACTERS: {
      MAX: {
        VALUE: 100,
        MESSAGE: '100文字以下で入力してください',
      },
    },
    SIXTY_CHARACTERS: {
      MAX: {
        VALUE: 60,
        MESSAGE: '60文字以下で入力してください',
      },
    },
    THIRTY_CHARACTERS: {
      MAX: {
        VALUE: 30,
        MESSAGE: '30文字以下で入力してください',
      },
    },
    TWENTY_FIVE_CHARACTERS: {
      MAX: {
        VALUE: 25,
        MESSAGE: '25文字以下で入力してください',
      },
    },
  },
  AMOUNT: {
    MAX: {
      VALUE: 10_000_000_000,
      MESSAGE: '100億円以下で入力してください',
    },
    FIFTEEN_HUNDRED: {
      VALUE: 1_500,
      MESSAGE: '1,500円以下で入力してください',
    },
    ONE_MILLION: {
      VALUE: 1_000_000,
      MESSAGE: '100万円以下で入力してください',
    },
  },
  URL: {
    FORMAT: {
      MESSAGE: '有効なURLを入力してください',
    },
  },
  APPROVERS: {
    SELECT_REQUIRED: {
      MESSAGE: '承認者を選択してください',
    },
  },
  PHONE_NUMBER: {
    REGEX: {
      VALUE: /^[0-9|０-９]{1,4}[-]?[0-9|０-９]{1,4}[-]?[0-9|０-９]{3,4}$/,
      MESSAGE: '電話番号を正しく入力してください',
    },
  },
  POSTAL_CODE: {
    REGEX: {
      VALUE: /^[0-9]{7}$/,
      MESSAGE: '7桁の半角数字で入力してください',
    },
  },
  ZENGIN_FOR_PAYMENT_REQUESTS: {
    REGEX: {
      // eslint-disable-next-line no-irregular-whitespace
      VALUE: /^[a-zA-Z0-9ａ-ｚＡ-Ｚ０-９ァ-ヶｦ-ﾟー－\-()（）．.ｰ\sﾞﾟ　]+$/,
      MESSAGE:
        '全角・半角の英数字カナ・スペース/一部の記号（(), （）, ．, ., ー, －, -, ｰ, ﾞ, ﾟ ）で入力してください',
    },
    AMOUNT: {
      MAX: {
        VALUE: 9_999_999_999,
        MESSAGE: '100億円未満で入力してください',
      },
    },
  },
}
